import React, { useState } from "react";
import { TOOLS_LIST } from "../utils/toolsConfig";

const ToolPage = () => {
  // Tracks the ID of the open tool (null means no tool modal is open)
  const [activeToolId, setActiveToolId] = useState(null);

  // Find the metadata block for whichever tool is currently open
  const activeTool = TOOLS_LIST.find((t) => t.id === activeToolId);
  const ActiveModalComponent = activeTool ? activeTool.modalComponent : null;

  return (
    <main className="dashboard-container" style={{ padding: "40px" }}>
      <h2 style={{ textAlign: "center", marginBottom: "30px" }}>Welcome to the Tools Dashboard</h2>
      
      {/* Dynamic Grid Layout for Cards */}
      <section 
        className="tool-gateway-grid" 
        style={{ 
          display: "grid", 
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", 
          gap: "20px",
          maxWidth: "1200px",
          margin: "0 auto"
        }}
      >
        {TOOLS_LIST.map((tool) => (
          <div 
            key={tool.id}
            className="tool-card" 
            onClick={() => setActiveToolId(tool.id)}
            style={{
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "30px 20px",
              cursor: "pointer",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              transition: "transform 0.2s, box-shadow 0.2s",
              backgroundColor: "#fff"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow = "0 8px 12px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.1)";
            }}
          >
            <h3 style={{ fontSize: "20px", marginBottom: "10px" }}>{tool.title}</h3>
            <p style={{ color: "#666", fontSize: "14px" }}>{tool.description}</p>
          </div>
        ))}
      </section>

      {/* Conditionally render the selected tool's modal dynamically */}
      {ActiveModalComponent && (
        <ActiveModalComponent onClose={() => setActiveToolId(null)} />
      )}
    </main>
  );
}

export default ToolPage;